import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppliancesFridge = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "appliances-fridge" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 3.75,
			y: .75,
			width: 16.5,
			height: 21,
			rx: 1.049,
			ry: 1.049
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6.75,
			y1: 21.75,
			x2: 6.75,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 17.25,
			y1: 21.75,
			x2: 17.25,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 3.75,
			y1: 8.25,
			x2: 20.25,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6.75,
			y1: 12.75,
			x2: 6.75,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6.75,
			y1: 3.75,
			x2: 6.75,
			y2: 5.25
		})
	]
});
export default SvgAppliancesFridge;
